import '../style/input-list.scss'
import { REG_NUMBER } from '../data/api'

export default {
  functional: true,
  render (h, context) {
    const props = context.props
    const searchList = props.searchList
    const [showList] = searchList

    const renderContent = () => {
      if (!showList) {
        return <div class='list-empty'>
          搜索无结果
        </div>
      }
      const child = searchList.map((item, index) => {
        const reg = new RegExp(props.keyWord, 'gi')
        const DistrictName = String(item.districtName).replace(reg, value => `<span style="color: var(--g-color-primary);">${value}</span>`)
        const showZone = REG_NUMBER.test(props.keyWord)
        const zoneCode = String(item.zoneCode).replace(reg, value => `<span style="color: var(--g-color-primary);">${value}</span>`)
        const createInner = () => {
          if (showZone) {
            return [
              <span class='district-zone' domPropsInnerHTML={zoneCode}></span>,
              <span class='district-name' domPropsInnerHTML={DistrictName} title={item.districtName}></span>
            ]
          } else {
            const allData = String(item.districAllName).split('-')
            const leng = allData.length
            let districAllName = item.districAllName
            if (leng > 1) {
              if (+item.level === 5) {
                districAllName = allData.slice(1, leng - 1).join('')
              } else {
                districAllName = allData.slice(0, leng - 1).join('')
              }
            }
            return [
              <span class='district-name' domPropsInnerHTML={DistrictName} title={item.districtName}></span>,
              <span class='distric-all-name' title={districAllName}>{districAllName}</span>
            ]
          }
        }
        const inner = createInner()
        return <div class='item' on-click={() => {
          props.handleSearchListItemClickEvent(item, index)
        }}>
          {inner}
        </div>
      })
      return <div class='list-wrap'>{child}</div>
    }
    const content = renderContent()
    return <div class='kye-area-search-list' style={props.inputListStyle}>
      <el-scrollbar
        wrap-class="kye-area-search-list-wrap"
        view-class="kye-area-search-list-list"
        ref="scrollbar"
      >
        {
          content
        }
      </el-scrollbar>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/components/input-list.js